<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="onHandleClose"
      width="50%"
      class="dialog"
      center
    >
      <div class="setup-contents">
        <el-form
          class="demo-cityForm"
          label-width="170px"
          ref="refCityForm"
          :model="cityForm"
          :rules="cityRules"
        >
          <el-form-item label="照片/视频更新时间：" prop="time_num">
            <div style="display: flex">
              <!-- <el-input-number
                v-model="cityForm.time_num"
                :min="0"
              ></el-input-number> -->
               <el-input
               style="width: 200px;"
           v-model="cityForm.time_num"
            placeholder="请输入照片/视频更新时间"
            clearable
          ></el-input>
              <el-select
                v-model="cityForm.time_type"
                style="margin-left: 20px; width: 100px"
                placeholder="请选择"
              >
                <el-option label="天" :value="1"> </el-option>
                <el-option label="月" :value="2"> </el-option>
              </el-select>
            </div>
          </el-form-item>
          <div
            style="
              color: #333333;
              width: 160px;
              text-align: right;
              margin-bottom: 10px;
            "
          >
            超售后率下架：
          </div>
          <!-- <el-form-item label="超售后率下架：" >
        </el-form-item> -->

          <el-form-item label="条件1超售后率：" prop="aftersale_percent">
            <div>
              <el-input
                v-model="cityForm.aftersale_percent"
                style="width: 200px"
                placeholder="请输入"
                clearable
                :disabled="multi_aftersale_percent==1?true:false"
              >
                <template slot="append">%</template></el-input
              >
               <el-checkbox @change="checkboxchange" style="margin-left: 20px;" :true-label="1" :false-label="0" v-model="multi_aftersale_percent">默认2倍</el-checkbox>
            </div>
          </el-form-item>

          <el-form-item label="条件2销量：" prop="name">
            <div style="display: flex; align-items: center">
              <div
                style="margin-left: -10px; margin-right: 20px; margin-top: -3px"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="没有条件2时，以条件1为判断标准，存在条件2时，以条件2为判断标准。"
                  placement="top-start"
                >
                  <el-button type="text"
                    ><i class="el-icon-info" style="font-size: 16px"></i
                  ></el-button>
                </el-tooltip>
              </div>
               <el-input
               style="width: 200px;"
          v-model="cityForm.sale_num"
            placeholder="请输入条件2销量"
            clearable
          ></el-input>
              <!-- <el-input-number
                v-model="cityForm.sale_num"
                :min="0"
              ></el-input-number
              > -->
              件
            </div>
          </el-form-item>
          <el-form-item
            label="质检报告更新时间："
            prop="inspection_report_pic_time_num"
          >
            <div style="display: flex">
              
                 <el-input
               style="width: 200px;"
          v-model="cityForm.inspection_report_pic_time_num"
            placeholder="请输入质检报告更新时间"
            clearable
          ></el-input>
              <!-- <el-input-number
                v-model="cityForm.inspection_report_pic_time_num"
                :min="0"
              ></el-input-number> -->
              <el-select
                v-model="cityForm.inspection_report_pic_time_type"
                style="margin-left: 20px; width: 100px"
                placeholder="请选择"
              >
                <el-option label="年" :value="3"> </el-option>
                <el-option label="月" :value="2"> </el-option>
                <el-option label="日" :value="1"> </el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="近10日商品日均销量：" prop="sales_10_day">
            <div>
              <el-input
                v-model="cityForm.sales_10_day"
                style="width: 200px"
                placeholder="请输入"
                clearable
                @input="(val) => cityForm.sales_10_day = val.replace(/[^\d]/g, '')"
              >
                <template slot="append">件</template></el-input
              >
            </div>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onHandleClose">取 消</el-button>
        <el-button
          type="primary"
          :loading="submitLoading"
          @click="onHandleSubmit"
          >确认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "setup",
  props: {},
  data() {
    const validateAmount = (rule, value, callback) => {
      const reg = /^\d+(\.\d{1,2})?$/;
      if (!reg.test(value)) {
        callback(new Error("最多两位小数"));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      submitLoading: false,

      dialogTitle: "设置",
multi_aftersale_percent:1,
      // 城市仓参数
      cityForm: {
        logistic_business_id: "", //	T文本	是	集配中心
        cids: [], //[0]	T文本	是	级分类数组
        time_type: 1, //	T文本	是	时间类型，1-天2
        time_num: '', //	T文本	是	时间值
        aftersale_percent: "", //	T文本	是	售后率
        sale_num: '', //	T文本	是	销量
        time_type: 1, //	T文本	是	时间类型，1-天2
        inspection_report_pic_time_num: '', //	T文本	是	时间值
        inspection_report_pic_time_type: 3, //时间类型，1-天 2月 3年
        sales_10_day: '0', //	T文本	是	近10日商品日均销量 0代表不限制
      },
      // 表单校验
      cityRules: {
       
    
      },
      rules1: {
        // time_num: [
        //   {
        //     required: true,
        //     message: "请输入照片/视频更新时间",
        //     trigger: ["blur", "change"],
        //   },
        // ],
        // inspection_report_pic_time_num: [
        //   {
        //     required: true,
        //     message: "请输入质检报告更新时间",
        //     trigger: ["blur", "change"],
        //   },
        // ],
    
      },
      rules:{
        //     aftersale_percent: [
        //   {
        //     required: true,
        //     message: "请输入条件1超售后率",
        //     trigger: ["blur", "change"],
        //   },
        //   { validator: validateAmount, trigger: "blur" },
        // ],
      }
    };
  },
  methods: {
    oninit(e, id) {
      Object.assign(this.$data.cityForm, this.$options.data().cityForm);
      this.$refs.refCityForm?.clearValidate();
      this.cityForm.logistic_business_id = id;
      if (e.length == 1) {
        this.$api.examine
          .downconfigdetail({
            logistic_business_id: id,
            cid: e[0].id,
          })
          .then((res) => {
            console.log(res, "1111");
            this.cityForm = res.data;
            this.multi_aftersale_percent = res.data.multi_aftersale_percent;
            this.checkboxchange()
            this.cityForm.cids = e.map((el) => el.id);
            this.dialogVisible = true;
          });
      } else {
        this.cityForm.cids = e.map((el) => el.id);
        this.cityForm.sale_num ='';
        // this.cityForm.sale_num =
        //   e[0].product_take_down_config.is_fruit_vegetable == 1 ? 20 : 0;
        this.dialogVisible = true;
        this.multi_aftersale_percent=1;
        this.checkboxchange()
      }

      console.log(e);
    },
    checkboxchange(){
      if(this.multi_aftersale_percent==1){
this.cityForm.aftersale_percent='';
  this.cityRules={
  ...this.rules1,
}
      }else{
this.cityRules={
  ...this.rules1,
  ...this.rules
}
      }

    },
    onHandleSubmit() {
      this.$refs.refCityForm.validate((valid) => {
        if (valid) {
          this.cityForm={
            ...this.cityForm,
            multi_aftersale_percent:this.multi_aftersale_percent
          }
          this.$api.examine.downconfigsave(this.cityForm).then((res) => {
            this.$message({
              message: "设置成功",
              type: "success",
            });
            this.$emit("setup", true);
            this.onHandleClose();
          });
        }
      });
    },
    /**
     * 关闭操作
     */
    onHandleClose() {
      Object.assign(this.$data.cityForm, this.$options.data().cityForm);
      this.$refs.refCityForm?.clearValidate();
      this.dialogVisible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.setup-contents {
  padding: 20px;
  box-sizing: border-box;
}
</style>
